import config from '../config'
import Cookies from 'js-cookie'
import qs from 'qs'

class CoreServices {
  constructor(service) {
    this.service = service
    this.apiEnpoint = `${config.API.ENDPOINT}${config.API.SUFFIX}`
    this.apiEnpointV1 = config.API.ENDPOINT_V1
  }

  headers(token) {
    if (token) {
      return new Headers({
        'Accept': 'application/json',
        'Content-type': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    } else {
      return new Headers({
        'Accept': 'application/json',
        'Content-type': 'application/json'
      })
    }
  }

  getToken() {
    return Cookies.get('access_token')
  }

  getAccessToken() {
    return Cookies.get('accessToken')
  }

  async GET_WITHOUT_ID(limit, skip, sort) {
    try {
      let query = qs.stringify({
        limit,
        skip,
        sort,
      })
      let response = await fetch(`${this.apiEnpoint}${this.service}${query ? `?${query}` : ''}`, {
        headers: this.headers(this.getToken()),
        method: 'GET'
      })
      let data = await response.json()

      return data
    } catch (error) {
      return { error }
    }
  }

  async GET_ID(id) {
    try {
      let response = await fetch(`${this.apiEnpoint}${this.service}/${id}`, {
        headers: this.headers(this.getToken()),
        method: 'GET'
      })
      let data = await response.json()
      return data
    } catch (error) {
      return { error }
    }
  }

  async FIND_ALL() {
    try {
      let response = await fetch(`${this.apiEnpoint}${this.service}/all`, {
        headers: this.headers(this.getToken()),
        method: 'GET'
      })
      let data = await response.json()
      return data
    } catch (error) {
      return { error }
    }
  }

  async CREATE(payload) {
    try {
      let response = await fetch(`${this.apiEnpoint}${this.service}`, {
        headers: this.headers(this.getToken()),
        method: 'POST',
        body: JSON.stringify(payload)
      })
      let data = await response.json()
      return data
    } catch (error) {
      return { error }
    }
  }

  async UPDATE_WITHOUT_ID(payload) {
    try {
      let response = await fetch(`${this.apiEnpoint}${this.service}`, {
        headers: this.headers(this.getToken()),
        method: 'POST',
        body: JSON.stringify(payload)
      })
      let data = await response.json()
      return data
    } catch (error) {
      return { error }
    }
  }

  async UPDATE(id, payload) {
    try {
      let response = await fetch(`${this.apiEnpoint}${this.service}/${id}`, {
        headers: this.headers(this.getToken()),
        method: 'POST',
        body: JSON.stringify(payload)
      })
      let data = await response.json()
      return data
    } catch (error) {
      return { error }
    }
  }

  async DELETE(id) {
    try {
      let response = await fetch(`${this.apiEnpoint}${this.service}/${id}`, {
        headers: this.headers(this.getToken()),
        method: 'DELETE'
      })
      let data = await response.json()
      return data
    } catch (error) {
      return { error }
    }
  }

}

export default CoreServices
